import { IEditInitialState } from '../types'

export const getSlideDataIndex = (state: IEditInitialState): number =>
  state.activeSlideData.data
    ? state.activeSlideData.data?.findIndex(
        ({ id }) => id === state.activeSlideDataID,
      )
    : -1
